import { Color } from "./colors.js";
const passRateCategories = [
  {
    minScore: 0.9,
    color: Color.Emerald
  },
  {
    minScore: 0.8,
    color: Color.Green
  },
  {
    minScore: 0.7,
    color: Color.Lime
  },
  {
    minScore: 0.6,
    color: Color.Amber
  },
  {
    minScore: 0.5,
    color: Color.Orange
  },
  {
    minScore: 0,
    color: Color.Red
  }
];
const fallbackCategory = {
  minScore: -Infinity,
  color: Color.Gray
};
function getPassRateCategory(score) {
  return passRateCategories.find((c) => score >= c.minScore) ?? fallbackCategory;
}
function getPassRateColor(score) {
  return getPassRateCategory(score).color;
}
export {
  getPassRateCategory,
  getPassRateColor
};
//# sourceMappingURL=passRate.js.map
